import { Box } from '@material-ui/core'
import { ReactComponent as ChannelsIconDark } from 'icons/channels-icon-dark.svg'
import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

const StyledChannelsIconDark = styled(Box)`
  && svg {
    height: 1.25rem;
    width: 1.25rem;
  }

  && svg .main-body {
    fill: ${props => props.theme.colors.accent};
  }

  && svg circle {
    stroke: ${props => props.theme.colors.accent1};
  }
`
export interface IChannelsIconProps {
  fill?: string
  active?: boolean
  size?: number
}

export const ChannelsIcon: FC<PropsWithChildren<IChannelsIconProps>> = () => {
  return (
    <StyledChannelsIconDark>
      <ChannelsIconDark />
    </StyledChannelsIconDark>
  )
}
